module.exports = __webpack_public_path__ + "img/USA-Best-1980 - 2009.a4042da2.png";